export const APP_VERSION: string = "{{APP_VERSION}}";
export const BASE_URL = process.env.REACT_APP_MODE === "prd" ? "" : "/";
export const API_URL =
    process.env.REACT_APP_MODE === "prd"
        ? "{{API_URL}}"
        : "https://dev.smart-acts.com/newlook/api";
